import dayjs from 'dayjs';
import { z } from 'zod';

export const baseNotificationRawSchema = z.object({
  id: z.union([z.number(), z.string()]),
  title: z.string(),
  text: z.string(),
  read: z.boolean(),
  created_at: z.string().transform((val) => dayjs.utc(val).local().toDate()),
});

export const baseNotificationRawSchemaParser = (raw: z.infer<typeof baseNotificationRawSchema>) => {
  return {
    id: raw.id,
    title: raw.title,
    text: raw.text,
    read: raw.read,
    createdAt: raw.created_at,
  };
};

export const baseNotificationSchema = baseNotificationRawSchema.transform(baseNotificationRawSchemaParser);

export type BaseNotificationEntityApi = z.input<typeof baseNotificationSchema>;

export type BaseNotificationEntity = z.infer<typeof baseNotificationSchema>;
